import React, { createElement } from "react";

const JobCell = ({ content, icon, isDetail = true }) => {
  return (
    content && (
      <div
        className="bg-wce-neutral-4 flex gap-2 rounded-lg py-1 px-4
        text-wce-neutral-8 items-center sm:justify-center w-full"
      >
        <div className="w-4 min-w-[16px]">
          {createElement(icon, { size: 16 })}
        </div>
        <div
          className={`text-xs sm:text-sm ${
            !isDetail && "overflow-ellipsis whitespace-nowrap overflow-hidden"
          }`}
        >
          {content}
        </div>
      </div>
    )
  );
};

export default JobCell;
